/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { ApiService } from "../services";
import { setLoyaltyPoint, setOrderDetails } from "../store";
import { API_SUCCESS_CODES } from "../constants";

export function useCreateOrderQuery(dispatch) {
  const { user, order, cart } = useSelector((state) => state);

  return useQuery({
    queryKey: [
      "create-order",
      cart.checkoutDetails?.checkoutId,
      cart.checkoutDetails?.cartHash
    ],
    queryFn: async () => {
      const response = await ApiService.post(
        `${order.shopDomain}/order/create`,
        {
          checkoutId: cart.checkoutDetails.checkoutId,
          userShopifyId: user?.shopifyDetails?.shopifyId || null
        },
        { authorization: `Bearer ${user.authToken}` }
      );

      if (!API_SUCCESS_CODES.includes(response.statusCode))
        throw new Error("Invalid request, something failed!");

      dispatch(setOrderDetails(response.data.order));
      if (response.data.order?.cart?.loyaltyDiscount)
        dispatch(setLoyaltyPoint(response.data.order));

      return response.data.order;
    },
    enabled: !!cart.checkoutDetails?.checkoutId,
    staleTime: Infinity
  });
}
